<template>
    <div class="w-full  m-w-1200">
        <!-- 搜索框 -->
        <div class="m-b-16">
            <el-input v-model="search_name" placeholder="Please input" class="input-with-select">
                <template #append>
                    <el-button type="primary" @click="search">
                        <el-icon>
                            <Search />
                        </el-icon>
                    </el-button>
                </template>
            </el-input>
        </div>
        <!-- 客户端内容 -->
        <div class="m-b-28 block bg-fff border-radius">
            <div class="p-12-20 title1 bg-fafafa">{{ $t(content_client.name) }}</div>
            <div class="p-12-20 border-bottom c-p" v-for="c in show_content" :key="c.id" @click="info(c.id)">
                <div class="title2 m-b-5">{{ $t(c.title) }}</div>
                <div class="title3">{{ c.updated_at }}</div>
            </div>
        </div>
        <!-- v2rayNG详情抽屉 -->
        <div>
            <el-drawer v-model="v2rayNG_drawer" :title="$t('document.v2rayNG.name')" size="80%">
                <div class="p-24">
                    <!-- 1 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.v2rayNG.step1') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="jumpToBuy()">{{ $t('document.v2rayNG.step1_content1')
                            }}</el-button>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.v2rayNG.step2') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step2_content1') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="subscribeApi()">{{ $t('document.v2rayNG.step2_content2')
                            }}</el-button>
                        </div>
                    </div>
                    <!-- 3 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.v2rayNG.step3') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="down('v2ray')">{{ $t('document.v2rayNG.step3_content1')
                            }}</el-button>
                        </div>
                    </div>
                    <!-- 4 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.v2rayNG.step4') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step4_content1') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step4_content2') }}</div>
                        <div>
                            <img style="width:280px;height:500px" src="../../assets/img/document/v2ray/1.jpeg" alt="" />
                        </div>
                    </div>
                    <!-- 5 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.v2rayNG.step5') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step5_content1') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step5_content2') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step5_content3') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step5_content4') }}</div>
                        <div>
                            <img class="m-r-5" style="width:280px;height:500px" src="../../assets/img/document/v2ray/2.jpeg"
                                alt="">
                            <img style="width:280px;height:500px" src="../../assets/img/document/v2ray/3.jpeg" alt="">
                        </div>
                    </div>
                    <!-- 6 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.v2rayNG.step6') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step6_content1') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step6_content2') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step6_content3') }}</div>
                        <div>
                            <img style="width:280px;height:500px" src="../../assets/img/document/v2ray/4.jpeg" alt="">
                        </div>
                    </div>
                    <!-- 7 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.v2rayNG.step7') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step7_content1') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.v2rayNG.step7_content2') }}</div>
                        <div>
                            <img style="width:280px;height:500px" src="../../assets/img/document/v2ray/5.png" alt="">
                        </div>
                    </div>
                </div>
            </el-drawer>
        </div>
        <!-- clash for windows详情抽屉 -->
        <div>
            <el-drawer v-model="clash_drawer" :title="$t('document.Clash_for_Windows.name')" size="80%">
                <div class="p-24">
                    <!-- 1 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Clash_for_Windows.step1') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="jumpToBuy()">{{
                                $t('document.Clash_for_Windows.step1_content1')
                            }}</el-button>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Clash_for_Windows.step2') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.Clash_for_Windows.step2_content1') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="subscribeApi()">{{
                                $t('document.Clash_for_Windows.step2_content2') }}</el-button>
                        </div>
                    </div>
                    <!-- 3 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Clash_for_Windows.step3') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="down('clash')">{{
                                $t('document.Clash_for_Windows.step3_content1') }}</el-button>
                        </div>
                    </div>
                    <!-- 4 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Clash_for_Windows.step4') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.Clash_for_Windows.step4_content1') }}</div>
                        <div>
                            <img style="height:500px" src="../../assets/img/document/clashforwindows/1.png" alt="" />
                        </div>
                        <div class="m-20-0 title10">{{ $t('document.Clash_for_Windows.step4_content2') }}</div>
                        <div>
                            <img style="height:500px" src="../../assets/img/document/clashforwindows/2.png" alt="" />
                        </div>
                        <div class="m-20-0 title10">{{ $t('document.Clash_for_Windows.step4_content3') }}</div>
                        <div>
                            <img style="height:500px" src="../../assets/img/document/clashforwindows/3.png" alt="" />
                        </div>
                    </div>
                </div>
            </el-drawer>
        </div>
        <!-- Shadowrocket详情抽屉 -->
        <div>
            <el-drawer v-model="Shadowrocket_drawer" :title="$t('document.Shadowrocket.name')" size="80%">
                <div class="p-24">
                    <!-- 1 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Shadowrocket.step1') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="jumpToBuy()">
                                {{ $t('document.Shadowrocket.step1_content1') }}</el-button>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Shadowrocket.step2') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.Shadowrocket.step2_content1') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="subscribeApi()">{{ $t('document.Shadowrocket.step2_content2')
                            }}</el-button>
                        </div>
                    </div>
                    <!-- 3 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Shadowrocket.step3') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="down('shadowrocket')">{{
                                $t('document.Shadowrocket.step3_content1') }}</el-button>
                        </div>
                    </div>
                    <!-- 4 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Shadowrocket.step4') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.Shadowrocket.step4_content1') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.Shadowrocket.step4_content2') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.Shadowrocket.step4_content3') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.Shadowrocket.step4_content4') }}</div>
                    </div>
                </div>
            </el-drawer>
        </div>
        <!-- FoXray详情抽屉 -->
        <div>
            <el-drawer v-model="foXray_drawer" :title="$t('document.FoXray.name')" size="80%">
                <div class="p-24">
                    <!-- 1 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.FoXray.step1') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="jumpToBuy()">{{ $t('document.FoXray.step1_content1')
                            }}</el-button>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.FoXray.step2') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.FoXray.step2_content1') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="subscribeApi()">{{ $t('document.FoXray.step2_content2')
                            }}</el-button>
                        </div>
                    </div>
                    <!-- 3 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.FoXray.step3') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="down('foXray')">{{ $t('document.FoXray.step3_content1')
                            }}</el-button>
                        </div>
                    </div>
                    <!-- 4 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.FoXray.step4') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.FoXray.step4_content1') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.FoXray.step4_content2') }}</div>
                        <div>
                            <img style="width:280px;height:500px" src="../../assets/img/document/foXray/1.png" alt="" />
                        </div>
                        <div class="m-20-0 title10">{{ $t('document.FoXray.step4_content3') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.FoXray.step4_content4') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.FoXray.step4_content5') }}</div>
                        <div>
                            <img style="width:280px;height:500px" src="../../assets/img/document/foXray/2.png" alt="" />
                        </div>
                    </div>
                </div>
            </el-drawer>
        </div>
        <!-- Official详情抽屉 -->
        <div>
            <el-drawer v-model="official_drawer" :title="$t('document.Official.name')" size="80%">
                <div class="p-24">
                    <!-- 1 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Official.step1') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="jumpToBuy()">{{ $t('document.Official.step1_content1')
                            }}</el-button>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Official.step2') }}</div>
                        <div class="m-20-0 f-FAFAFA  p-20">
                            <el-button type="primary" @click="down('official')">{{ $t('document.Official.step2_content1')
                            }}</el-button>
                        </div>
                    </div>
                    <!-- 3 -->
                    <div class="m-b-20">
                        <div class="title9 m-20-0">{{ $t('document.Official.step3') }}</div>
                        <div class="m-20-0 title10">{{ $t('document.Official.step3_content1') }}</div>
                    </div>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { Search } from '@element-plus/icons-vue'
import { subscribeApi } from '@/utils/api'
import { ElNotification } from 'element-plus'
import clipboard3 from 'vue-clipboard3'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex';
export default {
    components: { Search },
    setup() {
        const store = useStore();
        const { t } = useI18n()
        return { t, store }
    },
    data() {
        return {
            content_client: {
                name: 'document.title',
                content: [
                    {
                        id: 5,
                        title: 'document.Official.name',
                        en_title: 'Official Android client',
                        zh_title: '官方Android客户端',
                        por_title: 'Cliente oficial do Android',
                        updated_at: '2023/11/24'
                    },
                    {
                        id: 1,
                        title: 'document.v2rayNG.name',
                        en_title: 'Android Client -- v2rayNG',
                        zh_title: '安卓客户端 -- v2rayNG',
                        por_title: 'Cliente Android -- v2rayNG',
                        updated_at: '2023/09/20'
                    },
                    {
                        id: 2,
                        title: 'document.Clash_for_Windows.name',
                        en_title: 'Windows Client -- Clash for Windows',
                        zh_title: 'Windows 客户端 -- Clash for Windows',
                        por_title: 'Cliente Windows--Clash Para Windows',
                        updated_at: '2023/09/20'
                    },
                    {
                        id: 3,
                        title: 'document.Shadowrocket.name',
                        en_title: 'IOS Client - Shadowrocket',
                        zh_title: 'IOS 客户端 - Shadowrocket',
                        por_title: 'Cliente Ios-Shadowrocket',
                        updated_at: '2023/09/20'
                    },
                    {
                        id: 4,
                        title: 'document.FoXray.name',
                        en_title: 'IOS Client - FoXray',
                        zh_title: 'IOS 客户端 - FoXray',
                        por_title: 'Cliente IOS-FoXray',
                        updated_at: '2023/09/20'
                    },
                    
                ]
            },
            search_name: '',
            v2rayNG_drawer: false,
            clash_drawer: false,
            Shadowrocket_drawer: false,
            foXray_drawer: false,
            official_drawer:false,
            show_content: []
        }
    },
    methods: {
        down(name) {
            if (name === 'clash') {
                this.downLoad(window.ipConfig.clashUrl)
            } else if (name === 'v2ray') {
                this.downLoad(window.ipConfig.v2rayUrl)
            } else if (name === 'shadowrocket') {
                window.location.href = window.ipConfig.shadowrocketUrl
            } else if (name === 'foXray') {
                window.location.href = window.ipConfig.foXrayUrl
            }else if (name === 'official'){
                window.location.href = window.ipConfig.officialUrl
            }

        },
        downLoad(url) {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', '');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        info(id) {
            if (id === 1) {
                this.v2rayNG_drawer = true;
            } else if (id === 2) {
                this.clash_drawer = true;
            } else if (id === 3) {
                this.Shadowrocket_drawer = true;
            } else if (id === 4) {
                this.foXray_drawer = true;
            }else if(id === 5){
                this.official_drawer = true;
            }
        },
        jumpToBuy() {
            this.store.commit('updateActiveName', 'aside.purchase_subscription');
            this.store.commit('updateActivePath', '/shop');
            this.$router.push('/shop');
        },
        subscribeApi() {
            subscribeApi().then(res => {
                if (res !== undefined && res.data !== null) {
                    this.getLink(res.data)
                } else {
                    ElNotification({
                        message: 'Error',
                        type: 'error',
                    })
                }
            }).catch(err => {
                ElNotification({
                    message: err,
                    type: 'error',
                })
            })
        },
        async getLink(link) {
            const { toClipboard } = clipboard3();
            await toClipboard(link);
            return ElNotification({
                title: '',
                message: "success",
                type: 'success',
            })

        },
        search() {
            if (this.t('lang') === 'en') {
                this.show_content = this.content_client.content.filter(item => item.en_title.includes(this.search_name));
            } else if (this.t('lang') === 'zh') {
                this.show_content = this.content_client.content.filter(item => item.zh_title.includes(this.search_name));
            } else if (this.t('lang') === 'por') {
                this.show_content = this.content_client.content.filter(item => item.por_title.includes(this.search_name));
            }
        }
    },
    created() {
        this.show_content = this.content_client.content;
    }
}
</script>

<style scoped></style>